module.exports = __webpack_public_path__ + "img/Dozer.5d96fce4.png";